var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoPlaceholder = function SvgLogoPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.004 6.129H36.18V22.87H9.004Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "currentColor",
      fillOpacity: 1
    },
    d: "m23.54 9.992-.411.258 1.344-2.734a2.476 2.476 0 0 1 4.457.02l5.312 11.026c.094.192.242.348.426.454.332.191.742.183 1.066-.02l.41-.254-1.343 2.73a2.474 2.474 0 0 1-4.457-.019L25.03 10.43a1.047 1.047 0 0 0-1.492-.438Zm-8.657-.02c.183.106.332.266.426.458l5.312 11.023a2.476 2.476 0 0 0 4.457.02l1.344-2.73-.41.253c-.325.203-.735.211-1.067.02a1.037 1.037 0 0 1-.425-.453L19.207 7.534a2.474 2.474 0 0 0-4.457-.02l-1.344 2.735.41-.258c.325-.199.735-.207 1.067-.02ZM9.16 19.93l.735 1.523a2.48 2.48 0 0 0 4.46.024l1.344-2.735-.41.254a1.042 1.042 0 0 1-1.492-.433l-1.14-2.368c-.438-.906-1.727-.91-2.169-.008l-1.32 2.688a1.205 1.205 0 0 0-.008 1.055Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M14.484-6.828c0 1.406-.293 2.64-.875 3.703a6.213 6.213 0 0 1-2.421 2.469c-1.043.586-2.266.875-3.672.875-1.407 0-2.641-.29-3.704-.875a6.355 6.355 0 0 1-2.468-2.469C.758-4.188.469-5.422.469-6.828c0-1.414.289-2.649.875-3.703A6.254 6.254 0 0 1 3.812-13c1.063-.594 2.297-.89 3.704-.89 1.406 0 2.629.296 3.671.89a6.115 6.115 0 0 1 2.422 2.469c.582 1.054.875 2.289.875 3.703Zm-6.968 4.86c.894 0 1.675-.204 2.343-.61a4.294 4.294 0 0 0 1.563-1.719c.375-.726.562-1.57.562-2.531 0-.969-.187-1.817-.562-2.547a4.194 4.194 0 0 0-1.563-1.719c-.668-.406-1.449-.61-2.343-.61-.907 0-1.7.204-2.375.61-.68.406-1.204.98-1.579 1.719C3.188-8.645 3-7.797 3-6.828c0 .96.188 1.805.563 2.531.374.73.898 1.305 1.578 1.719.675.406 1.468.61 2.375.61Zm0 0",
    transform: "translate(37.385 21.85)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M-.078-12.094c-.133-.289-.145-.554-.031-.797.105-.25.27-.441.5-.578a1.41 1.41 0 0 1 .718-.203 1.4 1.4 0 0 1 .672.156c.188.094.336.262.453.5l4.72 9.063 4.64-9.016c.238-.469.601-.703 1.094-.703.257 0 .503.074.734.219.238.137.406.328.5.578.101.25.07.547-.094.89L8.078-.671C7.816-.222 7.441 0 6.953 0c-.23 0-.453-.055-.672-.172a1.112 1.112 0 0 1-.484-.531Zm0 0",
    transform: "translate(52.565 21.85)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M7.016-13.89c.226 0 .441.046.64.14.207.094.36.246.453.453l6.079 11.922c.187.313.238.59.156.828-.086.242-.25.43-.5.563a1.57 1.57 0 0 1-.766.203c-.2 0-.402-.059-.61-.172a1.088 1.088 0 0 1-.484-.453l-1.5-2.985H3.563l-1.5 2.985a.932.932 0 0 1-.47.484c-.21.094-.413.14-.609.14-.242 0-.48-.07-.718-.202a1.168 1.168 0 0 1-.5-.563c-.114-.238-.11-.492.015-.765l6.125-11.985c.114-.238.258-.394.438-.469.176-.082.398-.125.672-.125Zm0 3.624L4.609-5.469h4.813Zm0 0",
    transform: "translate(66.435 21.85)"
  })));
};
export default SvgLogoPlaceholder;